import useSWR from "swr";
import { SidebarType } from "../components/indice/side_bar";
import CacheService from "../services/custom_cache_service";
import API_GATEWAY from "./envConfig";

const fetcher = (url: string) => CacheService.get(url).then((res) => res.data);
const REFRESH_PERIOD_MILLIS = 1000 * 60 * 10;
export default function useSidebarService() {
  const { data, mutate, error, isValidating } = useSWR(
    `${API_GATEWAY}/api/sidebar`,
    fetcher,
    {
      revalidateOnFocus: false,
      //   revalidateOnMount: false,
      //   revalidateOnReconnect: false,
      refreshWhenOffline: false,
      //   refreshWhenHidden: false,
      refreshInterval: REFRESH_PERIOD_MILLIS,
    }
  );
  let sidebarData: SidebarType[] = [];
  if (data) {
    sidebarData = data["sidebar"] as SidebarType[];
  }
  const loading = !data && !error;
  return {
    loading,
    sidebar: sidebarData,
    mutate,
    isValidating,
  };
}
